import React from "react";
import commonFooterStyles from "../styles.module.css"


export function AppEndTag() {
    return (
        <div className={commonFooterStyles.end}>.</div>
    )
}